<template>
  <div class="m-top-dialog dialog">
    <div class="digest">
      <p class="top">
        <span>主题：</span>
        <span class="switch-btn" @click="switchHandle">切换主题</span>
      </p>
      <div class="content-box">
        <p class="broadcast-content">{{ info.txt }}</p>
      </div>
    </div>
    <div class="input-box">
      <el-input size="small" type="number" step="10" min="50" :disabled="hasJoin" placeholder="投入能量豆" @change="changeHandle" v-model="beans">
        <template slot="prepend"><span v-if="hasJoin">已</span>每天投放</template>
      </el-input>
      <el-input v-if="hasJoin" size="small" type="number" step="10" min="10" @change="changeHandle" v-model="addBeans">
        <template slot="prepend">追加能量豆数量</template>
      </el-input>
      <el-input size="small" type="number" min="1" :disabled="hasJoin" max="7" placeholder="投入能量豆" v-model="days">
        <template slot="prepend">置顶天数</template>
      </el-input>
    </div>
    <div style="display: flex;justify-content: flex-end;">
      <div class="total-box">
        <p style="font-size: 12px;" v-if="hasJoin">到期时间: {{ endTime }}</p>
        <p>
          <span class="label">合计:</span>
          <span class="price"> {{ !hasJoin ? beans * days : addBeans * days }}</span
          >能量豆
        </p>
      </div>
    </div>
    <div class="tip-box">
      <pre>
规则如下：
1. 根据对置顶主题投放的能量豆个数进行计算，以天为单位，每天投放的能量豆越多，该主题的展示位置越靠前。
2. 当主题展示的位置被挤下来时，可以再进行投放能量豆，系统将重新计算主题的展示位置。</pre
      >
    </div>
    <el-button type="warning" @click="setTop">确定置顶</el-button>
  </div>
</template>
<script>
import Chat from "@/api/chat";
export default {
  data() {
    return {
      beans: 50,
      days: 1,
      addBeans: 10,
      endTime: "",
      tip: ""
    };
  },
  methods: {
    changeHandle(e) {
      this.beans = Math.round(e / 10) * 10;
    },
    async setTop() {
      const beans = this.hasJoin ? this.addBeans : this.beans;
      const result = await Chat.setTop({
        beans: beans,
        days: this.days,
        id: this.info.msgId
      });
      if (result) {
        this.$toast.success("提交成功");
        this.$emit("success");
        this.$emit("update:visible", false);
      } else {
        this.$toast.fail("系统出错请稍后再试");
      }
    }
  },
  computed: {},
  props: {
    hasJoin: Boolean,
    visible: Boolean,
    info: Object,
    switchHandle: {
      type: Function,
      default: null
    }
  },
  mounted() {
    if (this.hasJoin) {
      Chat.getTopInfo(this.info.msgId).then(res => {
        this.endTime = res.EndTime;
        this.beans = res.DailyBeans;
        this.days = res.TopDays;
      });
    }
  }
};
</script>
<style lang="scss">
.m-top-dialog {
  .btn-box {
    position: relative;
    .tip {
      position: absolute;
      top: 5px;
      left: -10px;
    }
  }
}
</style>
